import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

import { reactive, ref, onMounted, watch } from "vue";
import { apiQuery } from "@/api/j24api";
import VSelectSearch from "@/components/VSelectSearch.vue";
import testData from "@/views/dashboard/reportTestData";
interface reportData {
  report: {
    [key: string]: {
      [key: string]: reportSoftwareTitle;
    };
  };
}

interface reportSoftwareTitle {
  publisher: string;
  name: string;
  appName: string;
  id: string;
  bundleId: string;
  currentVersion: string;
  previousVersion: string;
  versionIdentifier: string;
  reportData: {
    [key: string]: [reportComputerRecord];
  };
  numberOfDevices?: number;
  onCurrentVersion?: number;
}

interface reportComputerRecord {
  cfbundleversion: string;
  cfbundleidentifier: string;
  serial: string;
  cfbundleshortversionstring: string;
}

export interface mdmServer {
  _id: string;
  customerID: string;
  dataCollection: boolean;
  name: string;
  type: string;
  url: string;
  patchLicense: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardPatchingReport',
  setup(__props) {

console.log("Hello");

const mdmServers: mdmServer[] = reactive([]);
async function getMDMServers() {
  const mdmServersResult = await apiQuery("J24Auth", "elaadmin/mdmservers", {
    apiAction: "get",
  });
  const patchingLisensesResult = await apiQuery(
    "J24Auth",
    "elaadmin/mdmservers",
    { apiAction: "getPatchLicenses" }
  );
  if (mdmServersResult && patchingLisensesResult) {
    console.log("Processing MDM Results");
    mdmServersResult.forEach((mdmServer) => {
      patchingLisensesResult.forEach((license) => {
        console.log("MDM Server", mdmServer);
        console.log("License", license);
        if (license.mdmServerID == mdmServer._id) {
          console.log("Found Match");
          mdmServers.push({ ...mdmServer, patchLicense: license.name });
        }
      });
    });
  }
  // sort mdmServers by name
  mdmServers.sort((a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  });
}

const report: any = reactive([]);
const reportComplete = ref(false);
const selectedMDMServer: mdmServer = ref();
const disableReportButton = ref(true);
const alertTxt = ref("");
const maxAge = ref("14");

watch(selectedMDMServer, () => {
  disableReportButton.value = false;
});

async function getReport() {
  disableReportButton.value = true;
  alertTxt.value = "Requesting Report";
  const result = await apiQuery("ELA", "dashboard/patchingreport", {
    apiAction: "CreateReport",
    company: selectedMDMServer.value.patchLicense,
    reportStartFrom: maxAge.value,
    mdmServerId: "Testing",
  });
  const maxAttempts = 300;
  var count = 0;
  while (count < maxAttempts) {
    const reportData = await apiQuery("ELA", "dashboard/patchingreport", {
      apiAction: "CheckReport",
      reportID: result.reportRequestID,
    });
    console.log(reportData);
    if (reportData.complete) {
      count = 1000;
      processReportData(reportData.report);
      alertTxt.value = "";
      return;
    }
    if (reportData.state == "GATHERING RESULTS") {
      if (reportData.messageCount) {
        alertTxt.value =
          "Waiting for report data " +
          reportData.messageCount +
          " records found so far.";
      } else {
        alertTxt.value = "Waiting for report data...";
      }
    } else {
      alertTxt.value = "Unexpected response";
    }

    await sleep(6000);
    count++;
  }
  alertTxt.value = "Unable to get report";
}

async function getReportV2() {
  disableReportButton.value = true;
  alertTxt.value = "Requesting Report";
  var result = await apiQuery("ELA", "dashboard/patchingreport", {
    apiAction: "CreateReportV2",
    company: selectedMDMServer.value.patchLicense,
    reportStartFrom: maxAge.value,
    mdmServerId: "Testing",
  });
  const maxAttempts = 300;
  var count = 0;
  if (!result.reportRequests) {
    alertTxt.value = "Unable to create request";
    return;
  }
  console.log("Report Requests", result.reportRequests);
  var recordsFoundTotal = 0;
  while (count < maxAttempts) {
    for (let reportId of result.reportRequests) {
      console.log("Checking Report", reportId);
      const reportData = await apiQuery("ELA", "dashboard/patchingreport", {
        apiAction: "CheckReport",
        reportID: reportId,
      });
      if (reportData.complete) {
        processReportData(reportData.report);
        alertTxt.value = "";
        // remove reportId from result.reportRequests

        console.log(
          "Report Requests Length",
          result.reportRequests.length,
          result.reportRequests
        );
        if (result.reportRequests.length == 1) {
          console.log("Collecting data complete");
          reportComplete.value = true;
          count = 1000;
        }
        result.reportRequests = result.reportRequests.filter(
          (id) => id != reportId
        );
      } else {
        if (reportData.state == "GATHERING RESULTS") {
          if (reportData.messageCount) {
            recordsFoundTotal += reportData.messageCount;
            alertTxt.value =
              "Waiting for report data " +
              recordsFoundTotal +
              " records found so far.";
          } else {
            alertTxt.value = "Waiting for report data...";
          }
        } else {
          alertTxt.value = "Unexpected response";
        }
      }
    }
    await sleep(6000);
    count++;
  }
  //alertTxt.value = "Unable to get report";
}

function sleep(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

function countDevices(reportData: {
  [key: string]: [reportComputerRecord];
}): number {
  var count = 0;
  const keys = Object.keys(reportData);
  //console.log(keys);
  keys.forEach((key) => {
    count += reportData[key].length;
  });
  return count;
}

function countCurrentVersion(
  reportData: {
    [key: string]: [reportComputerRecord];
  },
  currentVersion: string
): number {
  var count = 0;
  const keys = Object.keys(reportData);
  //console.log(keys);
  keys.forEach((key) => {
    if (key == currentVersion) {
      count += reportData[key].length;
    }
  });
  return count;
}

function processSoftwareTitles(titles: { [key: string]: reportSoftwareTitle }) {
  console.log(Object.keys(titles));
  const keys = Object.keys(titles);
  var newTitles: [reportSoftwareTitle] = [];
  keys.forEach((key) => {
    //console.log(titles[key]);
    //newTitles[key] = titles[key];
    //console.log("Count Devices");
    //console.log(countDevices(titles[key].reportData));
    titles[key].numberOfDevices = countDevices(titles[key].reportData);
    titles[key].onCurrentVersion = countCurrentVersion(
      titles[key].reportData,
      titles[key].currentVersion
    );
    newTitles.push(titles[key]);
  });
  //console.log(newTitles);
  return newTitles;
}

function processReportData(data: reportData) {
  //console.log(Object.keys(data.report));
  for (const key in data.report) {
    //console.log(key);
    //console.log(data.report[key]);
    const titles = processSoftwareTitles(data.report[key]);
    //console.log(data.report[key]);
    titles.forEach((title) => {
      report.push({ stream: key, ...title });
    });
  }
}

const patchReportHeaders = [
  { text: "Application Name", value: "name", sortable: true },
  { text: "Architecture", value: "stream", sortable: true },
  {
    text: "Devices with App Installed",
    value: "numberOfDevices",
    sortable: true,
  },
  { text: "Current Version", value: "currentVersion" },
  {
    text: "Devices running Current Version",
    value: "onCurrentVersion",
    sortable: true,
  },
];

onMounted(() => {
  getMDMServers();
  //getReport();
  //for (const key in testData) {
  //processReportData(testData);
  //report.push(processReportData(testData));
  //}
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[5] || (_cache[5] = _createElementVNode("h4", null, "Patching Report", -1)),
    (!report.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(VSelectSearch, {
            items: mdmServers,
            label: "Choose MDM Server to Generate Report From",
            itemTitle: "name",
            "return-object": "",
            modelValue: selectedMDMServer.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedMDMServer).value = $event)),
            activateSearch: ""
          }, null, 8, ["items", "modelValue"]),
          _createVNode(_component_v_text_field, {
            label: "Choose Max Age of inventory records (days)",
            modelValue: maxAge.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((maxAge).value = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_btn, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (getReport())),
            disabled: disableReportButton.value
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Create Report")
            ])),
            _: 1
          }, 8, ["disabled"]),
          (alertTxt.value)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                class: "pt-3"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(alertTxt.value), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createBlock(_component_EasyDataTable, {
          key: 1,
          headers: patchReportHeaders,
          items: report,
          "theme-color": "#e7541e"
        }, {
          expand: _withCtx((item) => [
            _createVNode(_component_v_table, { class: "text-left" }, {
              default: _withCtx(() => [
                _cache[4] || (_cache[4] = _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Version"),
                  _createElementVNode("th", null, "Number of Devices")
                ], -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.reportData, (computerRecords, version) => {
                  return (_openBlock(), _createElementBlock("tr", { key: version }, [
                    _createElementVNode("td", null, _toDisplayString(version), 1),
                    _createElementVNode("td", null, _toDisplayString(computerRecords.length), 1)
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["items"]))
  ], 64))
}
}

})